var $=jQuery;
jQuery(document).ready(function ($) {
   $(".color-option").on("click", function() {
      let src = $(this).attr("src");
      if (src) {
         $('.custom-img-click').attr('srcset', '');
         $(this).closest('.card-wrapper').find('.custom-img-click2').attr('srcset', src);  
          $(this).closest('.card-wrapper').find('.custom-img-click').attr('srcset', src);  
          $(this).closest('.card-wrapper').find('.custom-img-click2').attr('src', src);  
          $(this).closest('.card-wrapper').find('.custom-img-click').attr('src', src);  
      }
    }); 
  
    setTimeout(function() { 
        $('.list-payment').css('opacity','1');
    }, 100);
    $('.select__select').on('change', function() {
        var selectedValue = $(this).val(); 
        var formAttribute = $(this).attr('form');
        $('#' + formAttribute).find('.product-variant-id').val(selectedValue);
        //console.log('Selected Value: ' + selectedValue);  
    });
  
    $('.footer-block.has-dropdown h2.footer-block__heading').click(function (e) { 
        e.preventDefault();
        $(this).toggleClass('active');
    });
    if ($(window).width() < 850) {
        $(".wrap-topbar").flickity({
            pageDots: false,
            freeScroll: false,
            wrapAround: true,
            prevNextButtons: false,
            autoPlay: 5000,
            groupCells: false,
            cellAlign: 'center',
        });
        var check_size = $(".icon-with-text .wrapper > .icon-with-text-item").length;
        if (check_size > 2) {
            $(".icon-with-text:not(.trust-st-single-top) .wrapper").flickity({
                pageDots: false,
                freeScroll: false,
                wrapAround: true,
                prevNextButtons: true,
                autoPlay: 3000,
                groupCells: false,
                cellAlign: 'center'
            });
          $(".icon-with-text.trust-st-single-top .wrapper").flickity({
                pageDots: false,
                freeScroll: false,
                wrapAround: true,
                prevNextButtons: true,
                autoPlay: 3000,
                groupCells: false,
                cellAlign: 'left'
            });
        }
        $(".slider-mb").flickity({
            pageDots: false,
            freeScroll: false,
            wrapAround: true,
            prevNextButtons: true,
            autoPlay: 5000,
            groupCells: false,
            cellAlign: 'left',
        });
       $('.has-slider-mb .grid').flickity({
            imagesLoaded: true,
            groupCells: false,
            dragThreshold: 5,
            cellAlign: 'center',
            wrapAround: true,
            prevNextButtons: true,
            percentPosition: true,
            pageDots: false,
            rightToLeft: false,
            autoPlay: false
        });
    }
    $('.slider-pdp').flickity({
        imagesLoaded: true,
        groupCells: false,
        dragThreshold: 5,
        cellAlign: 'center',
        wrapAround: true,
        prevNextButtons: true,
        percentPosition: true,
        pageDots: false,
        rightToLeft: false,
        autoPlay: false,
        sync: '.thumbnail-gallery'
    });
    $('.thumbnail-gallery').flickity({
        asNavFor: '.slider-pdp',
        groupCells: false,
        dragThreshold: 5,
        cellAlign: 'center',
        wrapAround: true,
        prevNextButtons: true,
        percentPosition: true,
        pageDots: false,
        rightToLeft: false,
        autoPlay: false
    });
  
    $('.has-mehr .image-with-text__content .image-with-text__text+.button').click(function (e) { 
        e.preventDefault();
        $(this).hide();
        $(this).closest('.has-mehr .image-with-text__content').find('.image-with-text__text').addClass('active');
    });
    $('.faq-scroll-tab a').click(function(e) {
        e.preventDefault(); 
    
        var targetId = $(this).attr('href').substring(1); 
        $('.faq-scroll-tab a').removeClass('active');
        $('.heading-block').removeClass('active');
        $('#' + targetId).addClass('active');
        $(this).addClass('active');
        
        $('html, body').animate({
        scrollTop: $('#' + targetId).offset().top - 100
        }, 600); 
    });
    $('.heading-block').first().addClass('active');
    if ($('.has-slider > *').length > 1) {
        $('.has-slider').flickity({
            imagesLoaded: true,
            groupCells: false,
            dragThreshold: 5,
            cellAlign: 'center',
            wrapAround: true,
            prevNextButtons: true,
            percentPosition: true,
            pageDots: false,
            rightToLeft: false,
            autoPlay: false
        });
    }
    if ($('.has-slider-multicolumn > *').length > 3) {
        $('.has-slider-multicolumn').flickity({
            imagesLoaded: true,
            groupCells: false,
            dragThreshold: 5,
            cellAlign: 'center',
            wrapAround: true,
            prevNextButtons: true,
            percentPosition: true,
            pageDots: false,
            rightToLeft: false,
            autoPlay: false
        });
    }
    if ($('.has-slider-left > *').length > 3) {
        $('.has-slider-left').flickity({
            imagesLoaded: true,
            groupCells: false,
            dragThreshold: 5,
            cellAlign: 'left',
            wrapAround: true,
            prevNextButtons: true,
            percentPosition: true,
            pageDots: false,
            rightToLeft: false,
            autoPlay: false
        });
    }

    // var maxHeight = 0;
    // $('.has-slider-left .card-wrapper .card__heading').each(function() {
    //     var currentHeight = $(this).outerHeight();
    //     if (currentHeight > maxHeight) {
    //     maxHeight = currentHeight;
    //     }
    // });
    // $('.has-slider-left .card-wrapper .card__heading').each(function() {
    //     $(this).css('height', maxHeight + 'px');
    // });
    var swiperInstance;

  function initSwiper() {
      if (swiperInstance && swiperInstance.destroy) {
          swiperInstance.destroy(true, true);
      }
  
      swiperInstance = new Swiper(".testimonials-section .swiper", {
          effect: "coverflow",
          grabCursor: true,
          centeredSlides: true,
          slidesPerView: 'auto',
          coverflowEffect: {
              rotate: 0,
              stretch: 0,
              depth: 100,
              modifier: 4,
              slideShadows: false
          },
          loop: true,
          navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev"
          },
          keyboard: {
              enabled: true
          },
          mousewheel: {
              thresholdDelta: 70
          },
          breakpoints: {
              1024: {
                  slidesPerView: 3
              }
          }
      });
  }
  
  window.addEventListener("resize", function () {
      initSwiper();
  });
  
  // Initial call to setup swiper
  initSwiper();


    $(document).on('click','.acctab_title', function(e){
        if($(window).width() >= 768){
            $('.acctab_title').removeClass('active-accor');
            $(this).addClass('active-accor');
            $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
            $($(this).attr('data-act-title')).addClass('activemain-tab').show();
        }else{
        $('.acctab_title').removeClass('active-accor');
            $(this).addClass('active-accor');
            $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
            $($(this).attr('data-act-title')).addClass('activemain-tab').show();
            // $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
            $('.acc_tab-inner .acc-tab-content').addClass('tab-content-show').show();
            $($(this).attr('data-act-title')).addClass('activemain-tab').show();
        }
    });
    $(document).on('click','.acc_tab-inner .acc-tab-content .back__arrow', function(e){
        $('.acc_tab-inner .acc-tab-content').removeClass('tab-content-show').show();
    });
    // $('.acc-container .acc:nth-child(1) .acc-head').addClass('active');
    // $('.acc-container .acc:nth-child(1) .acc-content').slideDown();
    $('.acc-head').on('click', function() {
        if($(this).hasClass('active')) {
            $(this).siblings('.acc-content').slideUp();
            $(this).removeClass('active');
        }
        else {
            $('.acc-content').slideUp();
            $('.acc-head').removeClass('active');
            $(this).siblings('.acc-content').slideToggle();
            $(this).toggleClass('active');
        }
    });
  // Show password
  const togglePassword = document.querySelector('.togglePassword');
  const password = document.querySelector('.CustomerPassword');
  if(togglePassword && password)
  {
    togglePassword.addEventListener('click', function (e) {
      const type = password.getAttribute('type') === 'password' ? 'text' : 'password';
      password.setAttribute('type', type);
      this.classList.toggle('show-password');
    });
  }
  initEventListeners();
  // Show password
  const togglePassword2 = document.querySelector('#confirm-password');
  const password2 = document.querySelector('#ForgotPassword');
  if(togglePassword2 && password2) {
    togglePassword2.addEventListener('click', function (e) {
      const type = password2.getAttribute('type') === 'password' ? 'text' : 'password';
      password2.setAttribute('type', type);
      this.classList.toggle('show-password');
    });
  }

  // custom reset pass //

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }
  function toggleRecoverPasswordForm() {
    var passwordForm = document.getElementById('RecoverPasswordForm').classList.toggle('hide');
    var loginForm = document.getElementById('CustomerLoginForm').classList.toggle('hide');
  }

  function initEventListeners() {
      // Show reset password form
      var recoverForm = document.getElementById('RecoverPassword');
      if (recoverForm) {
        recoverForm.addEventListener('click', function(evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
        });
      }
  
      // Hide reset password form
      var hideRecoverPassword = document.getElementById('HideRecoverPasswordLink');
      if (hideRecoverPassword) {
        hideRecoverPassword.addEventListener('click', function(evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
        });
      }
    }
});
  class PriceRange1 extends HTMLElement {
    connectedCallback() {
      this.rangeLowerBound = this.querySelector(".price-range__range-group input:first-child");
      this.rangeHigherBound = this.querySelector(".price-range__range-group input:last-child");
      this.textInputLowerBound = this.querySelector(".price-range__input:first-child input");
      this.textInputHigherBound = this.querySelector(".price-range__input:last-child input");
  
      // Event listeners for text input focus and change
      this.textInputLowerBound.addEventListener("focus", () => this.textInputLowerBound.select());
      this.textInputHigherBound.addEventListener("focus", () => this.textInputHigherBound.select());
  
      this.textInputLowerBound.addEventListener("change", (event) => {
        const newValue = Math.max(Math.min(parseInt(event.target.value), parseInt(this.textInputHigherBound.value || event.target.max) - 1), event.target.min);
        event.target.value = newValue;
        this.rangeLowerBound.value = newValue;
        this.updateRangeStyles();
      });
  
      this.textInputHigherBound.addEventListener("change", (event) => {
        const newValue = Math.min(Math.max(parseInt(event.target.value), parseInt(this.textInputLowerBound.value || event.target.min) + 1), event.target.max);
        event.target.value = newValue;
        this.rangeHigherBound.value = newValue;
        this.updateRangeStyles();
      });
  
      // Event listeners for range slider change and input
      this.rangeLowerBound.addEventListener("change", (event) => {
        this.textInputLowerBound.value = event.target.value;
        this.textInputLowerBound.dispatchEvent(new Event("change", { bubbles: true }));
      });
  
      this.rangeHigherBound.addEventListener("change", (event) => {
        this.textInputHigherBound.value = event.target.value;
        this.textInputHigherBound.dispatchEvent(new Event("change", { bubbles: true }));
      });
  
      this.rangeLowerBound.addEventListener("input", (event) => {
        this.dispatchEvent(new CustomEvent("collection:abort-loading", { bubbles: true }));
        event.target.value = Math.min(parseInt(event.target.value), parseInt(this.textInputHigherBound.value || event.target.max) - 1);
        this.textInputLowerBound.value = event.target.value;
        this.updateRangeStyles();
      });
  
      this.rangeHigherBound.addEventListener("input", (event) => {
        this.dispatchEvent(new CustomEvent("collection:abort-loading", { bubbles: true }));
        event.target.value = Math.max(parseInt(event.target.value), parseInt(this.textInputLowerBound.value || event.target.min) + 1);
        this.textInputHigherBound.value = event.target.value;
        this.updateRangeStyles();
      });
    }
  
    updateRangeStyles() {
      this.rangeLowerBound.parentElement.style.setProperty("--range-min", `${(parseInt(this.rangeLowerBound.value) / parseInt(this.rangeLowerBound.max)) * 100}%`);
      this.rangeHigherBound.parentElement.style.setProperty("--range-max", `${(parseInt(this.rangeHigherBound.value) / parseInt(this.rangeHigherBound.max)) * 100}%`);
    }
  }

  window.customElements.define("price-range1", PriceRange1);

/*** PDD SLIDER ***/

 var product_custom = document.querySelectorAll('.product-slider .product-grid li');
  if (product_custom.length > 4) {
    product_custom.forEach(function(product_item) {
      var product_slider = product_item.closest('.product-slider .product-grid');
      if (product_slider) {
        var flkty = new Flickity(product_slider, {
           pageDots: false,
          cellAlign: 'left',
          groupCells: true,
          wrapAround: true,
          autoPlay: false,
          prevNextButtons: true,
          freeScroll: true, 
        });
      }
    });
  }


var product_custom = document.querySelectorAll('.product-slider .product-grid li');
    if (product_custom.length > 4) {
      product_custom.forEach(function(product_item) {
        var product_slider = product_item.closest('.product-slider .product-grid');
        if (product_slider) {
          var flkty = new Flickity(product_slider, {
             pageDots: false,
            cellAlign: 'left',
            groupCells: true,
            wrapAround: true,
            autoPlay: false,
            prevNextButtons: true,
            freeScroll: true, 
          });
        }
      });
    }



$('.product-single__gallery').flickity({
      imagesLoaded: true,
      groupCells: false,
      dragThreshold: 5,
      cellAlign: 'center',
      wrapAround: true,
      prevNextButtons: true,
      percentPosition: true, 
      pageDots: false,
      rightToLeft: false,
      autoPlay: false,
      sync: '.product-single__thumbnails'
  }); 

$('.product-single__gallery').on('change.flickity', function(event, index) {
    var $thumbnails = $('.product-single__thumbnails li');
    $thumbnails.removeClass('active');  // Remove 'active' class from all thumbnails
    $thumbnails.eq(index).addClass('active');  // Add 'active' class to the current thumbnail
});
$('.product-single__thumbnails li').first().addClass('active');

// Thumbnail click event to change the gallery image
$('.product-single__thumbnails li').on('click', function() {
    var index = $(this).index();
    $('.product-single__gallery').flickity('select', index);  // Select the corresponding image in the gallery
});


document.addEventListener("DOMContentLoaded", function() {
    const thumbsScroller = document.querySelector(".product-single__thumbnails");
    const btnPrev = document.querySelector("button.product__thumb-arrow.product__thumb-arrow--prev");
    const btnNext = document.querySelector("button.product__thumb-arrow.product__thumb-arrow--next");
    const scrollStep = 100; 
    const scrolledClass = "scrolled-end";
    // const extraItemsClass = "has-extra-items";
    // const minItems = 6; 
    // const items = thumbsScroller ? thumbsScroller.children : [];

    let hasScrolled = false; 

    function updateButtonState() {
      const isAtTop = thumbsScroller.scrollTop === 0;
  
      const threshold = 5; 
      const isAtBottom =
          thumbsScroller.scrollTop + thumbsScroller.clientHeight >= thumbsScroller.scrollHeight - threshold;
  
      btnPrev.disabled = isAtTop;
      btnNext.disabled = isAtBottom;
  
      if (hasScrolled && isAtBottom) {
          thumbsScroller.classList.add(scrolledClass);
      } else {
          thumbsScroller.classList.remove(scrolledClass);
      }
    }


    // function addExtraItemsClass() {
    //     if (items.length > minItems) {
    //         thumbsScroller.classList.add(extraItemsClass);
    //     } else {
    //         thumbsScroller.classList.remove(extraItemsClass);
    //     }
    // }

    if (thumbsScroller) {
        btnPrev.addEventListener("click", () => {
            thumbsScroller.scrollBy({ top: -scrollStep, behavior: "smooth" });
        });

        btnNext.addEventListener("click", () => {
            thumbsScroller.scrollBy({ top: scrollStep, behavior: "smooth" });
        });

        thumbsScroller.addEventListener("scroll", () => {
            hasScrolled = true; 
            updateButtonState();
        });

        //addExtraItemsClass();

        updateButtonState();
    }
});



const scriptTag = $('script[data-selected-variant]').first();  
if (scriptTag.length) {
    const jsonData = JSON.parse(scriptTag.text().trim());
    const featuredMediaId = jsonData.featured_media?.id;  
    const sectionIdValue = $('input[name="section-id"]').val();
    const mediaId = `${sectionIdValue}-${featuredMediaId}`;
    
    if (mediaId) {
      var thumbnail = $(`li[data-att="${mediaId}"]`);
      // Trigger a click event on that element
      if (thumbnail.length) {
        thumbnail.click();
      }
    }
}


/*** PDD SLIDER ***/
// landing page js 
document.querySelectorAll('.botttom_btn-bar .button').forEach(b=>{
  b.onclick=e=>{
    if(b.hash){
      e.preventDefault();
      window.scrollTo({
        top: document.querySelector(b.hash).offsetTop - 60,
        behavior: 'smooth'
      });
    }
  }
});